import React from "react";
import { Box, Typography } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import { muiTheme } from "@/styles/theme";

interface InfoRowProps {
  icon: React.ReactNode;
  text?: string;
  children?: React.ReactNode;
  alignItems?: "center" | "flex-start";
  gap?: string;
  textSx?: object;
  color?: string;
  textDecoration?: string;
  cursor?: string;
  title?: string;
}
const InfoRow: React.FC<InfoRowProps> = ({
  icon,
  title,
  text,
  children,
  alignItems = "center",
  gap = nawyTheme.nawy.spacing.sm,
  textSx = {},
  color,
  textDecoration,
  cursor,
}) => {
  const defaultTextSx = {
    color,
    textDecoration,
    cursor,
    lineHeight:
      nawyTheme.nawy.typography.english.variants.body.md.regular.lineHeight,
    fontFamily: `${
      (muiTheme.components?.MuiCssBaseline?.styleOverrides as any)?.body
        ?.fontFamily
    }`,
    ...textSx,
  };

  const titleSx = {
    fontSize: nawyTheme.nawy.spacing.sm,
    color: nawyTheme.nawy.colors.semantic.text.secondary,
    lineHeight:
      nawyTheme.nawy.typography.english.variants.body.md.regular.lineHeight,
    marginBottom: nawyTheme.nawy.spacing.xxxs,
    fontFamily: `${
      (muiTheme.components?.MuiCssBaseline?.styleOverrides as any)?.body
        ?.fontFamily
    }`,
  };

  return (
    <Box sx={{ display: "flex", alignItems, gap }}>
      {icon}
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {title && <Typography sx={titleSx}>{title}</Typography>}
        {text ? <Typography sx={defaultTextSx}>{text}</Typography> : children}
      </Box>
    </Box>
  );
};

export default InfoRow;
